import * as React from 'react';
import * as PropTypes from 'prop-types';
import IconWrapper from './IconWrapper';

const IconWidgetResultsInquiry = props =>
  React.createElement(
    IconWrapper,
    props,
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      className="block w-full h-full fill-current"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.0629 17.6491C27.4406 18.052 27.4202 18.6848 27.0173 19.0625L21.6839 24.0625C21.2993 24.4232 20.7007 24.4232 20.3161 24.0625L17 20.9537L13.6839 24.0625C13.281 24.4403 12.6482 24.4199 12.2705 24.017C11.8927 23.614 11.9131 22.9812 12.3161 22.6035L16.3161 18.8535C16.7007 18.4929 17.2993 18.4929 17.6839 18.8535L21 21.9623L25.6494 17.6035C26.0523 17.2257 26.6851 17.2462 27.0629 17.6491Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7826 7.33333C14.2341 5.4222 15.9509 4 18 4H21.3333C23.3824 4 25.0993 5.4222 25.5507 7.33333H28C30.3932 7.33333 32.3333 9.27343 32.3333 11.6667V31.6667C32.3333 34.0599 30.3932 36 28 36H11.3333C8.9401 36 7 34.0599 7 31.6667V11.6667C7 9.27343 8.9401 7.33333 11.3333 7.33333H13.7826ZM13.7826 9.33333H11.3333C10.0447 9.33333 9 10.378 9 11.6667V31.6667C9 32.9553 10.0447 34 11.3333 34H28C29.2887 34 30.3333 32.9553 30.3333 31.6667V11.6667C30.3333 10.378 29.2887 9.33333 28 9.33333H25.5507C25.0993 11.2445 23.3824 12.6667 21.3333 12.6667H18C15.9509 12.6667 14.2341 11.2445 13.7826 9.33333ZM18 6C16.7113 6 15.6667 7.04467 15.6667 8.33333C15.6667 9.622 16.7113 10.6667 18 10.6667H21.3333C22.622 10.6667 23.6667 9.622 23.6667 8.33333C23.6667 7.04467 22.622 6 21.3333 6H18Z"
      />
    </svg>,
  );

IconWidgetResultsInquiry.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};
export default IconWidgetResultsInquiry;
